module.exports = __webpack_public_path__ + "static/img/scene-1.e177812.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene-1.jpg
// module id = gjn5
// module chunks = 73